export default [
    {
        path: '/house/add',
        name: 'house-create',
        component: () => import('@/views/house/house-form/HouseForm.vue'),
        meta: {
            resource: 'House',
            action: 'create',
        },
    },
    {
      path: '/house/edit/:id',
      name: 'house-edit',
      component: () => import('@/views/house/house-form/HouseForm.vue'),
      meta: {
        resource: 'House',
        action: 'update',
      },
    },
    {
        path: '/house/lists',
        name: 'house-list',
        component: () => import('@/views/house/house-list/HouseList.vue'),
        meta: {
            resource: 'House',
            action: 'read',
        },
    },
    {
        path: '/house/upload-image/:id',
        name: 'house-upload',
        component: () => import('@/views/house/house-upload/HouseUpload.vue'),
        meta: {
            resource: 'House',
            action: 'update',
        },
    },
]